<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/las_vegas_market/bg_las-vegas-market_entertainment-landscape.jpg" alt=""></transition></div>                                     
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Las Vegas Market" h1="Entertainment" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <p class='large yellow'>Elevating the Entertainment Landscape of Las Vegas</p>
                        <p>Allegiant Stadium has already proven that Las Vegas is hungry for large-scale events. The first announced Allegiant Stadium concert featuring Garth Brooks sold out 65,000 tickets in a mere 75 minutes*.</p>            
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageBottom>    
  </div>
</template>

<script>
import PageBottom from "@/patterns/PageBottom.vue";
import TitleContent from "@/patterns/TitleContent.vue";
export default {
  name: "TheStadium",
  components: { PageBottom, TitleContent },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
